import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { CloseLostPetListingComponent } from 'src/app/modals/close-lost-pet-listing/close-lost-pet-listing.component';
import { User } from 'src/app/interfaces/user';
import {
  PetMissingReportPublic,
  PetMissingReportStatus,
} from 'src/app/interfaces/pet';
import { Alert } from 'src/app/interfaces/alert';

@Component({
  selector: 'app-missing-pet-report',
  templateUrl: './missing-pet-report.component.html',
  styleUrl: './missing-pet-report.component.scss'
})
export class MissingPetReportComponent implements OnInit, OnDestroy {
  closeLostPetListingModalRef?: NgbModalRef;
  isMyPet = false;
  missingPetReport: PetMissingReportPublic;
  user: User;
  petMissingReportStatus = PetMissingReportStatus;
  startMapOpened: boolean;
  alert: Alert = null;
  lastSeenMapLocation: {
    lat: number,
    lng: number,
  }
  lastSeenDate: Date;

  constructor(
    public authManager: AuthManagerService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) {
    this.missingPetReport = this.route.snapshot.data.missingPetReport as PetMissingReportPublic;
    this.user = this.route.snapshot.data.user as User;
    this.lastSeenMapLocation = { lat: 54.11815748515591, lng: -2.541813085952347 };
  }

  closeListing() {
    this.closeAlert();
    const modalOptions: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md',
    };

    this.closeLostPetListingModalRef = this.modalService.open(CloseLostPetListingComponent, modalOptions);
    this.closeLostPetListingModalRef.componentInstance.pet = this.missingPetReport.pet;
    this.closeLostPetListingModalRef.componentInstance.reportId = this.missingPetReport.id;
    this.closeLostPetListingModalRef.result
        .then((reportStatus: PetMissingReportStatus) => {
          this.missingPetReport.reportStatus = reportStatus;
          if (this.missingPetReport.reportStatus === PetMissingReportStatus.ClosedFound) {
            this.alert = {
              type: 'success',
              message: 'Your lost pet report has been updated successfully.'
            };
          }
        })
        .catch((reason) => {
          if (reason) {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        });
  }

  closeAlert() {
    this.alert = null;
  }

  ngOnInit(): void {
    // Checking if the user is the keeper of the reported missing pet
    this.isMyPet = this.user && this.user.id === this.missingPetReport.pet.keeperId;

    if (this.missingPetReport.seenLocations?.length > 0) {
      const { latitude, longitude } = this.missingPetReport.seenLocations[this.missingPetReport.seenLocations.length - 1].location;
      this.lastSeenDate = this.missingPetReport.seenLocations[this.missingPetReport.seenLocations.length - 1].date;
      this.lastSeenMapLocation = { lat: latitude, lng: longitude };
    } else {
      const { latitude, longitude } = this.missingPetReport.lastSeen.location;
      if (latitude && longitude) {
        this.lastSeenMapLocation = { lat: latitude, lng: longitude };
      }
    }

    // Setting map accordion opened or closed
    this.startMapOpened = true;
  }

  ngOnDestroy(): void {
    this.closeLostPetListingModalRef?.dismiss('destroyed');
  }
}
